import { Button, Card, Col, Divider, Row, Space, Typography } from "antd";
import React, { useState } from "react";
import ClientAddressList from "./ClientAddressList";
import ClientForm from "./ClientForm";
import ClientList from "./ClientList";
import "./ClientStyles.css";

const { Title } = Typography;

const ClientManagement = () => {
	const [refreshKey, setRefreshKey] = useState(0);
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedClientForAddresses, setSelectedClientForAddresses] =
		useState(null);
	const [viewMode, setViewMode] = useState("form"); // 'form' | 'addresses'
	const isMobile = window.innerWidth < 768;

	// Esta función se ejecutará cuando se agregue un nuevo cliente
	const handleClientAdded = () => {
		// Incrementar el key para forzar la actualización de la lista de clientes
		setRefreshKey((prevKey) => prevKey + 1);
	};

	// Esta función se ejecutará cuando se edite un cliente
	const handleClientEdited = (client) => {
		setSelectedClient(client);
		setViewMode("form");
	};

	// Esta función se ejecutará cuando se actualice un cliente
	const handleClientUpdated = () => {
		// Limpiar el cliente seleccionado e incrementar el key para actualizar la lista
		setSelectedClient(null);
		setRefreshKey((prevKey) => prevKey + 1);
	};

	// Esta función se ejecutará cuando se quiera ver las direcciones de un cliente
	const handleViewAddresses = (client) => {
		setSelectedClientForAddresses(client);
		setViewMode("addresses");
	};

	return (
		<div className="client-management-container">
			<Title level={2}>{isMobile ? "Clientes" : "Gestión de Clientes"}</Title>
			<Divider />

			<Row gutter={[24, 24]}>
				<Col xs={24} lg={12}>
					<Card
						title={
							<Space>
								<span>
									{viewMode === "form"
										? "Formulario de Cliente"
										: "Direcciones del Cliente"}
								</span>
								{viewMode === "addresses" && (
									<Button size="small" onClick={() => setViewMode("form")}>
										Volver al Formulario
									</Button>
								)}
							</Space>
						}
					>
						{viewMode === "form" ? (
							<ClientForm
								onClientAdded={handleClientAdded}
								onClientUpdated={handleClientUpdated}
								clientToEdit={selectedClient}
							/>
						) : (
							<ClientAddressList
								clientNo={selectedClientForAddresses?.No}
								clientName={selectedClientForAddresses?.name}
							/>
						)}
					</Card>
				</Col>

				<Col xs={24} lg={12}>
					<ClientList
						refreshTrigger={refreshKey}
						onEditClient={handleClientEdited}
						onViewAddresses={handleViewAddresses}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default ClientManagement;
